export const MIME_TYPES = {
  JPG: ['image/jpeg'],
  PNG: ['image/png'],
};

export function areMimeTypesMatching(types: string[], mimeType: string): boolean {
  return types.includes(mimeType);
}
